import { share } from "@/api/public";

//微信分享
export function shareUrl(that) {
	/* console.log(share);
	console.log(that.wx); */
	return false;
	let url = window.location.href;
	let uri = '';
	var u = navigator.userAgent;
	var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
	var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
	if (isAndroid) {
		uri=location.href;
	}
	if (isIOS) {
		uri=location.href.split('#')[0];  //hash后面的部分如果带上ios中config会不对
	}
	//请求接口
	share({url: uri}).then(res => {
		if(res.data.code == 0){
			that.wx.config({
				debug: false,
				appId: res.data.data.appId,
				timestamp: res.data.data.timestamp,
				nonceStr: res.data.data.nonceStr,
				signature: res.data.data.signature,
				jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
			});
			that.wx.ready(function () {
				that.wx.updateAppMessageShareData({
					title: '保义通｜新冠自测人工智能系统',
					desc: '抗原自测流程指导；检测结果快速解读；历史记录一键查看～',
					link: location.href,
					imgUrl: 'https://imagepphcloud.thepaper.cn/pph/image/188/885/109.jpg',
					success: function () {
						console.log("分享成功");
					}
				});
				that.wx.updateTimelineShareData({ 
					title: '保义通｜新冠自测人工智能系统',
					link: location.href,
					imgUrl: 'https://imagepphcloud.thepaper.cn/pph/image/188/885/109.jpg',
					success: function () {
						console.log("分享成功");
					}
				});
			});
			that.wx.error(function(res) {
				console.log(res.errMsg);
			});
		}
	});
}